import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=635ef285&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports